import { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router'
import UserUpload from '../page/UserUpload';

class UserUploadPortal extends Component {
  render() {

    // Container ref
    let targetContainer = document.getElementById('react-user-upload-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
      <Router>
        <UserUpload />
      </Router>, targetContainer
    );
  }
}

export default UserUploadPortal;